import { router } from '../utils/router';
import { getDetailsPageUrl } from '../search/searchCreatedRouting';
function searchCreatedRoute(params) {
    const { searchParameters, hotelId, openCalendar } = params;
    const url = getDetailsPageUrl(searchParameters, Number(hotelId), openCalendar);
    return [url, undefined];
}
export function dealSelectedRouting(params) {
    router.push(params, searchCreatedRoute);
}
